// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:27:17

export default {
  "id": "bubble-shooter-blast",
  "slug": "bubble-shooter-blast",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5c194abe4f6b46c99ad09bb4ce68d5e2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5c194abe4f6b46c99ad09bb4ce68d5e2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bubble Shooter Blast",
      "description": "In the game you can become an experienced bubble shooter. You just need to choose a ball and shoot at the right place to burst the bubbles. You have to go through more than 200 levels, so play this exciting game and start popping bubbles. Collect and shoot 3 or more bubbles to experience a sweet victory! Blow up all the balloons with your quick thinking and tactics. The next level will be harder than the previous one. Are you ready to burst all the balloons in this game?",
      "instructions": "The goal of the game is to shoot balls, collect the same side by side in 3 or more pieces.\nControl on a mobile device: swipe/touch\nPC control: LMB",
      "genres": [
        "Bubble Shooter",
        "Puzzle"
      ],
      "tags": [
        "ball",
        "bubble"
      ]
    },
    "zh-CN": {
      "title": "泡泡射击爆破",
      "description": "在游戏中，你可以成为一名经验丰富的泡泡射击者。你只需选择一个球并射向正确的位置来爆破泡泡。你必须通过200多个关卡，所以玩这款激动人心的游戏，开始爆破泡泡吧。收集并射击3个或更多泡泡，体验甜蜜的胜利！运用你的快速思考和策略，爆掉所有气球。下一个关卡将比上一个更难。你准备好在这款游戏中爆掉所有气球了吗？",
      "instructions": "游戏目标是射击球，将相同颜色的球排列在一起，组成3个或更多。\n\n移动设备控制：滑动/触摸\nPC控制：左鼠标键",
      "genres": [
        "泡泡射击",
        "拼图"
      ],
      "tags": [
        "球",
        "气泡"
      ]
    },
    "zh-TW": {
      "title": "泡泡射手爆破",
      "description": "在遊戲中，你可以成為一位經驗豐富的泡泡射手。你只需選擇一顆球並射向正確的位置來爆破泡泡。你必須通過超過200個關卡，所以來玩這款刺激的遊戲，開始爆破泡泡吧！收集並射擊3個或以上的泡泡，體驗甜蜜的勝利！用你的敏捷思考和策略引爆所有氣球。下一關將比上一關更難。你準備好爆破這款遊戲中的所有氣球了嗎？",
      "instructions": "遊戲的目標是射擊球體，將相同方向的3個或更多個球體並排收集。\n在移動設備上的控制：滑動/觸控\nPC上的控制：左鍵點擊",
      "genres": [
        "泡泡射擊",
        "拼圖"
      ],
      "tags": [
        "球",
        "泡泡"
      ]
    },
    "zh-HK": {
      "title": "泡泡射擊爆破",
      "description": "在遊戲中，你可以成為一名經驗豐富的泡泡射擊手。你只需選擇一顆球並射向正確的位置來爆破泡泡。你必須通過超過200個關卡，所以玩這款刺激的遊戲並開始爆破泡泡。收集並射擊3個或以上的泡泡，體驗甜蜜的勝利！用你的敏捷思考和策略爆破所有氣球。下一關將比上一關更難。你準備好爆破遊戲中的所有氣球了嗎？",
      "instructions": "遊戲目標是射擊球，將三個或以上連續排列的相同球收集起來。\n手機設備控制：滑動/觸控\n電腦控制：左鍵按鈕",
      "genres": [
        "泡泡射擊",
        "謎題"
      ],
      "tags": [
        "球",
        "泡泡"
      ]
    },
    "ja": {
      "title": "バブルシューターボム",
      "description": "ゲームでは、経験豊かなバブルシューターよりなれる。ただし、ボールを選んで正しい場所に撃つことでバブルを爆破するだけ。200以上のレベルをクリアしなければならないので、この興味深いゲームをプレイしてバブルを爆破し始めよう。3つ以上のバブルを集め、甘い勝利を体験しよう！素早い思考と戦術ですべてのバルーンを爆破しよう。次のレベルは前のレベルよりも難しくなる。このゲームですべてのバルーンを爆破する準備はできていますか？",
      "instructions": "ゲームの目的はボールを撃ち、3個以上连续に並べた同じボールを集めることです。\nモバイルデバイスでの操作：スワイプ/タッチ\nPCでの操作：左ボタンクリック",
      "genres": [
        "バブルシュータ",
        "パズル"
      ],
      "tags": [
        "ボール",
        "バブル"
      ]
    },
    "ko": {
      "title": "발포버블 슈터 블랙스터",
      "description": "게임에서 경험 있는 바ブル셋터가 될 수 있습니다. 단지 구슬을 선택하고 적절한 위치에 쏘아서 바ブル을 터뜨리면 됩니다. 200여 개의 레벨을 통과해야 하므로, 이 흥미로운 게임을 플레이하고 바ブル을 터뜨리기 시작하세요. 3개 이상의 바ブル을 모으고 맛있는 승리를 경험하세요! 신속한 사고와 전략으로 모든气球을 터뜨리세요. 다음 레벨은 이전 레벨보다 더 어렵습니다. 이 게임에서 모든气球을 터뜨리기 위해 준비가 되셨나요?",
      "instructions": "게임의 목표는 공을 발사하고, 3개 이상의 공을 연속으로 모으는 것입니다.\n모바일 기기 조작: 슬라이드/터치\nPC 조작: 마우스 왼쪽 버튼",
      "genres": [
        "버블슈터",
        "퍼즐"
      ],
      "tags": [
        "볼",
        "발포막"
      ]
    },
    "fr": {
      "title": "Tir Bubble Bash",
      "description": "Dans le jeu, vous pouvez devenir un tireur expérimenté de bulles. Vous devez simplement choisir une balle et tirer à la bonne place pour éclater les bulles. Vous devez passer plus de 200 niveaux, donc jouez à ce jeu captivant et commencez à éclater les bulles. Collectez et tirez 3 ou plus de bulles pour expérimenter une victoire douce ! Explosez tous les ballons avec votre pensée rapide et vos tactiques. Le prochain niveau sera plus difficile que le précédent. Êtes-vous prêt à éclater tous les ballons dans ce jeu ?",
      "instructions": "L'objectif du jeu est de tirer des balles, de les collecter côte à côte en 3 ou plus.\nContrôle sur appareil mobile : glisser/toucher\nContrôle sur PC : clic gauche",
      "genres": [
        "Tir de Bulles",
        "Puzzle"
      ],
      "tags": [
        "balle",
        "bulle"
      ]
    }
  }
};
